import { render, staticRenderFns } from "./Closing_report.vue?vue&type=template&id=6c3c35a2&scoped=true&"
import script from "./Closing_report.vue?vue&type=script&lang=js&"
export * from "./Closing_report.vue?vue&type=script&lang=js&"
import style0 from "./Closing_report.vue?vue&type=style&index=0&id=6c3c35a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c35a2",
  null
  
)

export default component.exports